import { environment } from "../../app/conf";
import { ENVIRONMENTS } from "../../home/components/NewSideBar/types";

export const getDomain = () => {
  switch (environment) {
    case ENVIRONMENTS.LOCAL:
      return "localhost";
    case ENVIRONMENTS.LOCAL_NGINX:
      return "team-blue.denwaip.com";
    default: {
      // Derive the apex from the current hostname so the same build works on
      // multiple domains (e.g. omuni-crm.denwaip.com and omuni-crm.omuni.ai).
      const host = window.location.hostname;
      const parts = host.split(".");
      if (parts.length >= 2) {
        return `.${parts.slice(-2).join(".")}`;
      }
      return host;
    }
  }
};

export const generateDuration = () => {
  // Duration of the cookie in hours
  const cookieDurationHours = 24;

  // Calculate the expiration date
  const expirationDate = new Date();

  expirationDate.setTime(
    expirationDate.getTime() + cookieDurationHours * 60 * 60 * 1000
  );

  return expirationDate;
};

/**
 * Checks whether a JWT is expired by reading its `exp` claim.
 * A malformed or missing token is treated as expired so callers fail closed.
 */
export const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};
